var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlurActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0e0333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 23C26.5 26.5899 23.5899 29.5 20 29.5C16.4101 29.5 13.5 26.5899 13.5 23C13.5 22.1205 13.7892 20.8897 14.2834 19.506C14.7735 18.1335 15.4499 16.6528 16.1896 15.2886C16.9303 13.9223 17.7258 12.6887 18.4495 11.8042C18.8122 11.3608 19.1453 11.0195 19.4335 10.7935C19.7379 10.5548 19.9227 10.5 20 10.5C20.0773 10.5 20.2621 10.5548 20.5665 10.7935C20.8547 11.0195 21.1878 11.3608 21.5505 11.8042C22.2742 12.6887 23.0697 13.9223 23.8104 15.2886C24.5501 16.6528 25.2265 18.1335 25.7166 19.506C26.2108 20.8897 26.5 22.1205 26.5 23Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27C22 27 24 25 24 23",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurActive);
export default __webpack_public_path__ + "static/media/blur-active.7755d08e619c4989fd0f9fc616482f1b.svg";
export { ForwardRef as ReactComponent };